import axios from 'axios';
import {
  GET_RAFFLE_RESULTS_REQUEST,
  GET_RAFFLE_RESULTS_SUCCESS,
  GET_RAFFLE_RESULTS_FAILURE,
  SET_RAFFLE_LIST_POSITION,
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
import { openModal } from 'Store/actions';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getRaffleResults = () => async dispatch => {
  try {
    dispatch({
      type: GET_RAFFLE_RESULTS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/digital-lottery/draws/result?gameType=RAFFLE`);
    dispatch({
      type: GET_RAFFLE_RESULTS_SUCCESS,
      payload: res.data.body
    });


    return res.data;

  } catch (e) {
    if (e.response.status !== 200) {
      dispatch(openModal('raffleErrorModal', { turnBackSantra: true, forceBackOnClose: true }));
    }
    dispatch({
      type: GET_RAFFLE_RESULTS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const setRaffleListScrollPosition = scrollPosition => async dispatch => {
  dispatch({
    type: SET_RAFFLE_LIST_POSITION,
    payload: scrollPosition
  });
};